import React from "react";
import "./Recommended_Products.css";
import { useLocation } from "react-router-dom";
import { IDS } from "../../../utils/common";

const Recommended_Products = () => {
  const location = useLocation();
  const crop = location.state?.crop;

  return (
    <section className="recommend_products py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="gallery_title">Recommended Solutions</h2>

          <p className="gallery_subtitle">Explore our Results</p>
        </div>

        <div className="row">
          {crop?.Gallery_Images?.map((gallery, index) => (
            <div
              className="col-lg-4 col-md-4 col-sm-6 mb-4"
              key={gallery.id || index}
            >
              <div className="gallery_card">
                <img
                  src={IDS?.IMG_URL + gallery.gallery_images}
                  alt={`Gallery ${index + 1}`}
                  className="gallery_img"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Recommended_Products;
